module.exports = __webpack_public_path__ + "static/img/projectService_2.e44a97e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mainPage/projectService_2.jpg
// module id = HiQc
// module chunks = 0